import { useEffect, useState } from "react";
import {
  FormLabel,
  FormItem,
  FormControl,
  FormMessage,
  FormField,
} from "@/components/ui/form";
import { FileUpload } from "@/components/component/file-upload";

export function OutlineFileUploadFormField({
  title = "Upload Files",
  description = "Upload additional documents in PDF or Word format.",
  form,
}) {
  const [files, setFiles] = useState([]);

  useEffect(() => {
    if (files) {
      form.setValue("files", files);
    }
  }, [files, form]);

  return (
    <div className="grid grid-cols-2 items-start md:col-span-2 border rounded-md p-4 h-full w-full space-y-2 bg-[var(--gray-50)]">
      <div>
        <FormLabel className="text-base">{title}</FormLabel>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
      <FormField
        control={form.control}
        name="files"
        render={({ field, fieldState: { error } }) => (
          <FormItem>
            <FormControl>
              <FileUpload
                files={files}
                setFiles={setFiles}
                inputProps={{
                  postOnChange: (e) => {
                    field.onChange(files); // Pass the array of files to the form
                  },
                  accept: ".pdf,.doc,.docx",
                  multiple: true,
                }}
                containerProps={{
                  className: "h-32",
                }}
              />
            </FormControl>
            {error && <FormMessage>{error.message}</FormMessage>}
          </FormItem>
        )}
      />
    </div>
  );
}
